import ReactCountryFlag from 'react-country-flag';
import { MdOutlineRemoveCircle } from 'react-icons/md';
import { useProvinceContext } from '../../../contexts/ProvinceProvider';

const SelectedProvincesTable = () => {
  // integration of context hooks here
  const { selectedProvinces, setSelectedProvinces } = useProvinceContext();

  // rendering selected provinces table component here
  return (
    <div
      className={`border-2 border-dashed border-legal-dark-blue rounded-lg overflow-x-auto ${
        !selectedProvinces.length ? 'hidden lg:block' : ''
      }`}
    >
      <div className='min-w-[800px] lg:min-w-full'>
        <div className='grid grid-cols-[200px_repeat(5,_minmax(0,_1fr))_50px] text-center border-b-2 border-dashed border-legal-dark-blue text-legal-dark-blue font-semibold [&>p]:py-2 [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue'>
          <p>Province Name</p>
          <p>Legal Age</p>
          <p>GST</p>
          <p>HST</p>
          <p>PST</p>
          <p>Country</p>
          <p></p>
        </div>

        {selectedProvinces.map((province, index) => (
          <div
            key={index}
            className={`grid grid-cols-[200px_repeat(5,_minmax(0,_1fr))_50px] text-center [&>p]:py-2 [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue ${
              index !== selectedProvinces.length - 1
                ? 'border-b border-dashed border-legal-dark-blue text-legal-dark-blue'
                : 'border-0 lg:border-b border-dashed border-legal-dark-blue text-legal-dark-blue'
            }`}
          >
            <p title={province.province_name} className='w-full truncate px-1'>
              {province.province_name}
            </p>
            <p>{province.legal_age}</p>
            <p>{province.gst}</p>
            <p>{province.hst}</p>
            <p>{province.pst}</p>
            <p>
              <ReactCountryFlag
                style={{ width: '1.6em', height: '1.6em' }}
                countryCode={province.iso_code as string}
                svg
              />
            </p>
            <div className='flex items-center justify-center'>
              <button
                onClick={() =>
                  setSelectedProvinces((state) =>
                    state.filter(
                      (existingProvince) =>
                        existingProvince.province_code !==
                        province.province_code
                    )
                  )
                }
                className='rounded-full'
              >
                <MdOutlineRemoveCircle className='size-5 text-base-red hover:opacity-70 duration-300' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedProvincesTable;
